import { ReactNode } from "react";
import styles from "./SegmentedToggle.module.css";

export interface SegmentedOption<V extends string> {
  value: V;
  label: string;
  icon?: ReactNode;
  /** A number printed after the label — how much is behind that option. */
  count?: ReactNode;
}

interface Props<V extends string> {
  options: SegmentedOption<V>[];
  value: V;
  onChange: (next: V) => void;
  "aria-label"?: string;
}

export function SegmentedToggle<V extends string>({
  options,
  value,
  onChange,
  "aria-label": ariaLabel,
}: Props<V>) {
  return (
    <div role="group" aria-label={ariaLabel} className={styles.root}>
      {options.map((opt) => {
        const isActive = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            aria-pressed={isActive}
            className={`${styles.opt} ${isActive ? styles.active : ""}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.icon && <span className={styles.icon}>{opt.icon}</span>}
            <span>{opt.label}</span>
            {opt.count !== undefined && (
              <span className={styles.count}>{opt.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
